import { ContactTypeCreatePage } from "@/features/contact/pages/ContactTypeCreate";
import { FC } from "react";

type TContactTypeCreateProps = {
  isCompany: boolean;
};

const ContactTypeCreate: FC<TContactTypeCreateProps> = ({ isCompany }) => {
  return <ContactTypeCreatePage isCompany={isCompany} />;
};

export default ContactTypeCreate;
